export default [

  {path: '/events', name: 'medtastic.events', component: require('~/pages/Events').default},
  {path: '/events/:id', name: 'medtastic.event_detail', component: require('~/pages/EventDetail').default},
  {path: '/events/:id/thanks', name: 'medtastic.event_thanks', component: require('~/pages/EventThanks').default},
  {path: '/contact', name: 'medtastic.contact', component: require('~/pages/contact').default},
  ...middleware('auth', [
    {path: '/medtastic/workshops', name: 'medtastic.workshop_list', component: require('~/pages/medtastic/WorkShopList').default},
    {path: '/medtastic/workshops/:id', name: 'medtastic.workshop_detail', component: require('~/pages/medtastic/WorkShopDetail').default},
    {path: '/medtastic/workshops/view/:id', name: 'medtastic.workshop_detail_view', component: require('~/pages/medtastic/WorkShopDetailView').default},
    {
      path: '/medtastic/configuration', component: require('~/pages/medtastic/configuration').default,
      children: [
        {path: '', redirect: {name: 'medtastic.configuration.notification_email_list'}},
        {path: 'notification_emails', name: 'medtastic.configuration.notification_email_list', component: require('~/pages/medtastic/configuration/NotificationEmailList').default},
        {path: 'notification_emails/:id', name: 'medtastic.configuration.notification_email_detail', component: require('~/pages/medtastic/configuration/NotificationEmailDetail').default},
      ]
    }
  ]),

  {path: '*', component: require('~/pages/errors/404.vue').default}
]

/**
 * @param  {String|Function} middleware
 * @param  {Array} routes
 * @return {Array}
 */
function middleware(middleware, routes) {
  routes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  )

  return routes
}
